import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import Sidebar from '../components/Sidebar';
import { useSidebarWidth } from '../store/useSidebarStore';
import { useDocumentTitle } from './useDocumentTitle';

const RootLayout: React.FC = () => {
  // the content follows the sidebar's width; nothing inside the pages has to know
  const sidebarWidth = useSidebarWidth();
  useDocumentTitle();
  return (
    <Box
      sx={{
        display: 'flex',
        height: '100vh'
      }}
    >
      <Sidebar />
      <Box
        sx={{
          flexGrow: 1,
          marginLeft: `${sidebarWidth}px`,
          transition: 'margin-left 200ms ease',
          height: '100%',
          width: '100%',
          background: 'white'
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default RootLayout;
